import { Component, OnInit, OnDestroy, EventEmitter, Output, ViewChild } from '@angular/core';
import { NavigationService, INavigationData } from '../../service';
import { SubSink } from 'subsink';
import { MenuItem } from 'primeng/api';
import { AppRoutes } from "../../../../app/shared/lib/api-constant";
import { SharedFilterService } from '../../service/filter-service/shared-filter.service';
import { ContractsCommonService } from '../../service/contract-creation/contracts-common.service';
import { Router } from '@angular/router';
import { finalize, skip, tap } from 'rxjs';
import { MultiSelect } from 'primeng/multiselect';
import { ToastService, ToastType } from '../../service/toast/toast.service';
import { FilterServiceService } from '../../service/FilterService/filter-service.service';
import { FilterServiceUnMapped } from '../../service/FilterService/filter-service-unmapped.service';
import { FilterTerminatedService } from '../../service/FilterService/filter-service-terminated.service';
import { FilterPanelComponent } from '../filter-panel/filter-panel.component';


@Component({
  selector: 'app-content-header',
  templateUrl: './content-header.component.html',
  styleUrls: ['./content-header.component.scss'],
  standalone :false,
})

export class ContentHeaderComponent implements OnInit, OnDestroy {
  @Output() toggleFilter = new EventEmitter<boolean>();
  @ViewChild('regionMultiSelect') regionMultiSelect: MultiSelect;
  @ViewChild('countryMultiSelect') countryMultiSelect: MultiSelect;
  @ViewChild('filterPanel') filterPanel: FilterPanelComponent;
  showFilterActive: boolean = false;
  display: boolean;
  isFilterPanelOpen: boolean = false;
  showFilterButton: boolean = false;
  breadcrumbs: MenuItem[] | null = null;
  home: MenuItem;
  private subscription = new SubSink();
  viewTypeOptions: any[] = [{ label: 'Days View', value: 0 }, { label: 'Cost View', value: 1 }];
  viewType: number = 0;
  pageCtrl: any = {
    regionFilter: false,
    viewTypeVisibility: false,
      listViewSelectVisibility: false   
  };
  currentNav: INavigationData;

  regions: any[] = [];
  countries: any[] = [];

  selectedRegion: any[] = [];
  selectedRegionIds: number[] = [];
  selectedCountry: any[] = [];

  selectedCountriesLabel: string = 'Select Countries';
  selectedRegionsLabel: string = 'Select Regions';
  allRegions: any;
  originalCountries: any[];
	listViewValues: string[] = [ORIGIN];
selectedListViewLabel: string = 'Origin';
  private getBreadcrumbs(routeType: string): MenuItem[] {
    let breadcrumbs: MenuItem[] = [];
    switch (routeType) {
      case AppRoutes.User.HOME:
        this.pageCtrl.regionFilter = true;
        this.pageCtrl.viewTypeVisibility = true;
         this.pageCtrl.listViewSelectVisibility = true; 
        breadcrumbs = [{ label: 'Home' }];
        break;
      case AppRoutes.User.LIST_VIEW:
        this.pageCtrl.regionFilter = true;
         this.pageCtrl.listViewSelectVisibility = true;
        breadcrumbs = [{ label: 'List View' },{ label: 'Active' }];
        break;
      case AppRoutes.User.LIST_VIEW_UNMAPPED:
        this.pageCtrl.regionFilter = true;
         this.pageCtrl.listViewSelectVisibility = false;
        breadcrumbs = [{ label: 'List View' },{ label: 'Uncontracted' }];
        break;
      
        case AppRoutes.User.LIST_VIEW_TERMINATED:
        this.pageCtrl.regionFilter = true;
         this.pageCtrl.listViewSelectVisibility = true;
        breadcrumbs = [{ label: 'List View' },{ label: 'Completed' }];
        break;
        // todo soemthing bread crumbs addition
      case AppRoutes.User.STATUS_CONFIGURATION:
        breadcrumbs = [{ label: 'User Configuration' }, { label: 'Status Configuration' }];
        break;
      case AppRoutes.User.PORT_CONFIGURATION:
        breadcrumbs = [{ label: 'User Configuration' }, { label: 'Port Configuration' }];
        break;
      case AppRoutes.User.RELEASE_NOTES:
        breadcrumbs = [{ label: 'Release Note' }];
        break;
      case AppRoutes.User.CONTRACT_AGREEMENT_CREATION:
        // this.pageCtrl.regionFilter = true;
        breadcrumbs = [{ label: 'Contract Agreement' }, { label: 'Contract Agreement Creation' }];
        break;
      case AppRoutes.User.CONTRACT_AGREEMENT_APPROVAL:
        // this.pageCtrl.regionFilter = true;
        breadcrumbs = [{ label: 'Contract Agreement' }, { label: 'Contract Agreement Approval' }];
        break;
      case AppRoutes.User.CONTRACT_CSV_UPLOAD:
        breadcrumbs = [
          { label: 'Contract Agreement' },
          { label: 'Contract Agreement Creation', routerLink: AppRoutes.User.CONTRACT_AGREEMENT_CREATION },
          { label: 'Contract Agreement CSV Upload' }];
        break;
      case AppRoutes.User.CONTRACT_CSV_HISTORY:
        breadcrumbs = [
          { label: 'Contract Agreement' },
          { label: 'Contract Agreement Creation', routerLink: AppRoutes.User.CONTRACT_AGREEMENT_CREATION },
          { label: 'Contract Agreement CSV Upload', routerLink: AppRoutes.User.CONTRACT_CSV_UPLOAD },
          { label: 'History Tab' }];
        break;
      case AppRoutes.User.ROLE_MANAGEMENT:
        breadcrumbs = [{ label: 'Master Data Management' }, { label: 'Role Management' }];
        break;
      case AppRoutes.User.USER_MANAGEMENT:
        breadcrumbs = [{ label: 'Master Data Management' }, { label: 'User Management' }];
        break;
      case AppRoutes.User.USER_MANAGEMENT_CONFIG:
        breadcrumbs = [{ label: 'Master Data Management' }, { label: 'User Management', routerLink: AppRoutes.User.USER_MANAGEMENT }, { label: 'User Configuration' }];
        break;
      case AppRoutes.User.PORT_MASTER_DATA_MANAGEMENT:
        breadcrumbs = [{ label: 'Master Data Management' }, { label: 'Port Master' }];
        break;
      case AppRoutes.User.COMPANY_MANAGEMENT:
        breadcrumbs = [{ label: 'Master Data Management' }, { label: 'Company Master' }];
        break;
      case AppRoutes.User.CURRENCY_MANAGEMNT:
        breadcrumbs = [{ label: 'Master Data Management' }, { label: 'Currency Management' }];
        break;
      case AppRoutes.User.ALERT_SUBSCRIPTION:
        breadcrumbs = [{ label: 'Alert Subscription' }];
        break;
      default:
        breadcrumbs = [];
        break;
    }
    return breadcrumbs;
  }

  constructor(
    public router: Router,
    private contractCommonService: ContractsCommonService,
    private sharedFilterService: SharedFilterService,
    private navigationService: NavigationService,
    private toastService: ToastService,
    private filterService: FilterServiceService,
    private unmappedFilterService: FilterServiceUnMapped,
    private terminatedFilterService: FilterTerminatedService
  ) {
    this.filterService.$isShowFilterActive.subscribe((isActive) => {
      this.showFilterActive = isActive;
    });
    this.subscription.add(
      this.navigationService.$currentNav.subscribe((selectedNav: INavigationData) => {
        if (selectedNav) {
            this.resetPortTypeToDefault();

          this.currentNav = selectedNav;
          this.pageCtrl.regionFilter = false;
          this.pageCtrl.viewTypeVisibility = false;
          this.breadcrumbs = this.getBreadcrumbs(selectedNav.routeType);
          //add the new route condiiton for new compoannet
          this.showFilterButton = (selectedNav.routeType === AppRoutes.User.LIST_VIEW) ||(selectedNav.routeType === AppRoutes.User.LIST_VIEW_UNMAPPED) ||
            (selectedNav.routeType === AppRoutes.User.CONTRACT_AGREEMENT_CREATION) || (selectedNav.routeType === AppRoutes.User.CONTRACT_AGREEMENT_APPROVAL)
            ||(selectedNav.routeType === AppRoutes.User.LIST_VIEW_TERMINATED);
        }
              if (
        selectedNav.routeType === AppRoutes.User.HOME ||
        selectedNav.routeType === AppRoutes.User.LIST_VIEW||
         selectedNav.routeType === AppRoutes.User.LIST_VIEW_UNMAPPED ||
         selectedNav.routeType === AppRoutes.User.LIST_VIEW_TERMINATED
      ) {
        this.resetPortTypeToDefault();
      }

      })
    )
  }

  ngOnInit() {
    this.loadRegionAndCountryData();
  }

  subscribeToCompanyChanges() {
    this.subscription.add(
      this.sharedFilterService.selectedCompanies$.pipe(skip(1)).subscribe((companies: any) => {
        if (companies) {
          this.resetFilters(); // Now safe to reset only on actual company change
          this.sharedFilterService.updateDashboardFilter({
            regionIdList: this.selectedRegionIds,
            regionList: this.selectedRegion,
            countryList: this.selectedCountry,
            pageUrl: this.router.url,
            companyList: companies
          });
        }
      })
    );
  }

  appendFilter() {
    const routerDetails = {
      url: this.router.url,
      regionFilter: this.selectedRegion,
      regionIdFilter: this.selectedRegionIds,
      countryFilter: this.selectedCountry
    }
    this.filterService.changeFilterVisibility(routerDetails);
  }

  onFilterClick() {
    const routerDetails = {
      url: this.router.url,
      filterVisibility: true,
      regionFilter: this.selectedRegion,
      regionIdFilter: this.selectedRegionIds,
      countryFilter: this.selectedCountry
    }
      if(this.router.url.includes("list-view-unmapped")){
      this.unmappedFilterService.changeFilterVisibility(routerDetails);
    } else {
      this.filterService.changeFilterVisibility(routerDetails);
    }
    if (this.router.url.includes("list-view-terminated")) {
      this.terminatedFilterService.changeFilterVisibility(routerDetails);
    }
  }

  loadRegionAndCountryData() {
    this.contractCommonService.getPortHierarchy()
      .pipe(
        tap({
          next: (response: any) => {
            if (response?.data) {
              this.allRegions = response.data;
              this.regions = response.data.map((region: any) => ({
                id: region.regionId,
                label: region.regionName,
                value: region.regionName
              }));
              this.originalCountries = response.data.flatMap((region: any) =>
                region.countries.map((country: any) => ({
                  label: country.countryName,
                  value: country.countryCode
                }))
              );
              this.resetFilters(); // Default selection on page load
              localStorage.setItem('regionList', JSON.stringify(this.regions));
              localStorage.setItem('countryList', JSON.stringify(this.originalCountries));
              this.sharedFilterService.markAsInitialized();
            }
          },
          // complete: () => console.log("Port hierarchy API call completed.") 
        }),
        finalize(() => this.subscribeToCompanyChanges()) // Ensures subscription starts only after API is done
      )
      .subscribe();
  }

  resetFilters() {
    this.selectedRegion = this.regions.map(region => region.value);
    this.selectedRegionIds = this.regions.map(region => region.id);
    this.selectedCountry = this.originalCountries.map(country => country.value);
    this.countries = [...this.originalCountries];
    this.updateLabels();
  }

  resetRegionFilter() {
    if (this.selectedRegion.length === 0) {
      this.selectedCountry = [];
      this.countries = [...this.originalCountries];
    } else {
      this.selectedCountry = [];
      this.countries = this.allRegions
        .filter((region: any) => this.selectedRegion.includes(region.regionName))
        .flatMap((region: any) =>
          region.countries.map((country: any) => ({
            label: country.countryName,
            value: country.countryCode
          }))
        );
      this.selectedCountry = this.countries.map(country => country.value);  
    }
    this.updateLabels();
  }

  onViewTypeChange() {
    this.sharedFilterService.updateDashboardFilter({
      viewType: this.viewType
    });


  }

  showNoRegionSelectionError() {
    this.toastService.showToast(ToastType.ERROR, `At least 1 Region should be selected.`, 5000);
  }

  onRegionChange() {
    if (!this.selectedRegion.length) {
      this.showNoRegionSelectionError();
      setTimeout(() => {
        this.regionMultiSelect.show();
      }, 500);
      return;

    }
    this.resetRegionFilter();
    this.sharedFilterService.updateDashboardFilter({
      regionIdList: this.selectedRegionIds,
      regionList: this.selectedRegion,
      countryList: this.selectedCountry
    });
  }

  onCountryChange() {
    this.updateLabels();
    this.sharedFilterService.updateDashboardFilter({
      countryList: this.selectedCountry
    });
  }

  updateLabels() {
    this.selectedRegionsLabel =
      this.selectedRegion.length === this.regions.length
        ? 'All Regions Selected'
        : this.selectedRegion.length > 2
          ? ` ${this.selectedRegion.length} Regions Selected`
          : this.selectedRegion.join(', ');

    this.selectedCountriesLabel = this.selectedCountry.length === 0 ? 'Select Countries' :
      this.selectedCountry.length === this.countries.length
        ? 'All Countries Selected'
        : this.selectedCountry.length > 2
          ? `${this.selectedCountry.length} Countries Selected`
          : this.countries.filter(country => this.selectedCountry.includes(country.value)).map(item => item.label).join(', ');

  

  }

  updateSelectedRegionIds() {
    // Filter regions to match selectedRegion and extract their IDs
    this.selectedRegionIds = this.regions
      .filter(region => this.selectedRegion.includes(region.value))
      .map(region => region.id);
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }


listViewOptions: any[] = [
  { label: 'Origin', value: ORIGIN },
  { label: 'Destination', value: DESTINATION }
];

listViewValue: string = "origin";
onListViewSelectChange() {

  if (!this.listViewValues || this.listViewValues.length === 0) {
    this.toastService.showToast(
      ToastType.ERROR,
      'At least one Port Type should be selected.',
      1000
    );
    return;
  }
  let portType: string;
  if (this.listViewValues.length === 2) {
    portType = 'both';
  } else {
    portType = this.listViewValues[0]; 
  }
  this.selectedListViewLabel = this.listViewValues.length === 2
    ? 'Both Selected'
    : this.listViewOptions.find(o => o.value === this.listViewValues[0])?.label;

  this.sharedFilterService.updatePortType(portType, true);

}

private resetPortTypeToDefault(): void {
  
  this.listViewValues = [ORIGIN];
  this.selectedListViewLabel = 'Origin';
  this.sharedFilterService.updatePortType('origin', true);
}




}
const ORIGIN = 'origin';
const DESTINATION = 'destination';